var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Country",
    transform: "translate(-28.831 28.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(28.831 -28.25)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2561440_flag_icon",
    "data-name": "2561440_flag_icon",
    transform: "translate(34.83 -21.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34430",
    "data-name": "Path 34430",
    d: "M4,9.469a3.793,3.793,0,0,1,2.47-.575c1.853,0,3.088,1.149,4.94,1.149a3.793,3.793,0,0,0,2.47-.575V2.575a3.793,3.793,0,0,1-2.47.575C9.557,3.149,8.323,2,6.47,2A3.793,3.793,0,0,0,4,2.575Z",
    fill: "none",
    stroke: "#39be9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_862",
    "data-name": "Line 862",
    y1: 5,
    transform: "translate(4 9.35)",
    fill: "none",
    stroke: "#39be9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/Country.cfd76ffd8046737fe7dbe762b31d3a6f.svg";
export { ForwardRef as ReactComponent };